import React from 'react'

const ComplianceLabs = () => {
  return (
      <div class="col-md-8 col-12 mb-2 pb-1">
          <div class="card mb-0 border-0 shadow-none ">
              <div class="card-header sh_accordionheader">
                  <div class="d-flex justify-content-between align-items-center">
                      <h6 class="text-md font-weight-bold mb-0">Compliance and Labs </h6>
                      <div>
                          <a class="btn btn-light sh_btnlight">View Report</a>
                      </div>
                  </div>
              </div>
              <div class="card-body sh_dashtableoverflowcard px-0 pt-0 mt-2 pb-2">
                  <table class="table dataTable sh_tablenew">
                      <thead>
                          <tr>
                              <th class="text">Employee</th>
                              <th class="text">Type</th>
                              <th class="text">status</th>
                              <th class="text">Due Date</th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr>
                              <td class="forTable_textEllipsis">Jhon Smith</td>
                              <td class="forTable_textEllipsis">Physicals</td>
                              <td class="forTable_textEllipsis"><span class="badge bg-green-soft text-green">Completed</span></td>
                              <td class="forTable_textEllipsis">10/09/2025</td>
                          </tr>
                          <tr>
                              <td class="forTable_textEllipsis">Emily Jhonson</td>
                              <td class="forTable_textEllipsis">Drug screen</td>
                              <td class="forTable_textEllipsis"><span class="badge bg-red-soft text-red">Overdue</span></td>
                              <td class="forTable_textEllipsis">10/09/2025</td>
                          </tr>
                          <tr>
                              <td class="forTable_textEllipsis">Jhon Smith</td>
                              <td class="forTable_textEllipsis">Physicals</td>
                              <td class="forTable_textEllipsis"><span class="badge bg-green-soft text-green">Completed</span></td>
                              <td class="forTable_textEllipsis">10/09/2025</td>
                          </tr>
                          <tr>
                              <td class="forTable_textEllipsis">Emily Jhonson</td>
                              <td class="forTable_textEllipsis">Drug screen</td>
                              <td class="forTable_textEllipsis"><span class="badge bg-red-soft text-red">Overdue</span></td>
                              <td class="forTable_textEllipsis">10/09/2025</td>
                          </tr>
                          <tr>
                              <td class="forTable_textEllipsis">Jhon Smith</td>
                              <td class="forTable_textEllipsis">Physicals</td>
                              <td class="forTable_textEllipsis"><span class="badge bg-green-soft text-green">Completed</span></td>
                              <td class="forTable_textEllipsis">10/09/2025</td>
                          </tr>
                          <tr>
                              <td class="forTable_textEllipsis">Emily Jhonson</td>
                              <td class="forTable_textEllipsis">Drug screen</td>
                              <td class="forTable_textEllipsis"><span class="badge bg-red-soft text-red">Overdue</span></td>
                              <td class="forTable_textEllipsis">10/09/2025</td>
                          </tr>
                          <tr>
                              <td class="forTable_textEllipsis">Jhon Smith</td>
                              <td class="forTable_textEllipsis">Physicals</td>
                              <td class="forTable_textEllipsis"><span class="badge bg-green-soft text-green">Completed</span></td>
                              <td class="forTable_textEllipsis">10/09/2025</td>
                          </tr>
                          <tr>
                              <td class="forTable_textEllipsis">Emily Jhonson</td>
                              <td class="forTable_textEllipsis">Drug screen</td>
                              <td class="forTable_textEllipsis"><span class="badge bg-red-soft text-red">Overdue</span></td>
                              <td class="forTable_textEllipsis">10/09/2025</td>
                          </tr>
                      </tbody>
                  </table>
              </div>
          </div>
      </div>
  )
}

export default ComplianceLabs